import React from 'react';

export const CheckboxField = ({ id, checked, onChange, label }) => {
  const handleChange = (e) => {
    const { value } = e.target;
    onChange(value);
  }

  return (
    <label class="checkbox-container form-checkbox mb-3">
      <input type="checkbox" value={id} checked={checked} onChange={handleChange} className='form-check-input'/>
      <span class="checkboxmark form-check-label">{label}</span>
    </label>
  );
};

